var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('h1',[_vm._v(_vm._s(_vm.$t("APIS")))]),_c('h2',[_vm._v(_vm._s(_vm.$t("MAIN API")))]),_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('WHAT_CAN_APIS_DO', {
        documentationLink:
          'https://api.dbservices.to/v1.7/spec/',
      })
    )}}),_c('h2',[_vm._v(_vm._s(_vm.$t("STATUS_API")))]),_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('STATUS_API_DESC', {
        statusLink:
          'https://status.dbservices.to/API/v1.0/spec/',
      })
    )}}),_c('template',{slot:"sidebar"},[_c('h2',[_vm._v(_vm._s(_vm.$t("TERMS OF USE FOR APIS")))]),_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('TOS_API_DESC')
      )}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }